import { render } from "./PageUpdateHasilTesKognitif.vue?vue&type=template&id=0e59c3b4"
import script from "./PageUpdateHasilTesKognitif.vue?vue&type=script&lang=js"
export * from "./PageUpdateHasilTesKognitif.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__